import { useCallback } from 'react';
import type {
	ChildResult,
	CommandSections,
} from '@atlassian/jira-command-palette/src/common/types/commands/index.tsx';
import { useIntl } from '@atlassian/jira-intl';
import { QUICK_SEARCH_PRIORITY } from '../../../../../common/ui/constants.tsx';
import { useGetQuickSearchProjectCommands } from '../../../../../common/ui/project/index.tsx';
import type {
	GetQuickSearchChildResultProps,
	UseGetChildResult,
} from '../../../../../common/ui/types.tsx';
import { messages } from './messages.tsx';

const SECTION_ID = 'jira.project';

export const useGetSearchProjectsChildResult: UseGetChildResult = () => {
	const { formatMessage } = useIntl();

	const { getQuickSearchProjectCommands } = useGetQuickSearchProjectCommands({
		section: SECTION_ID,
		showViewAll: true,
	});
	const getChildResult = useCallback(
		(props: GetQuickSearchChildResultProps): ChildResult => {
			const sections: CommandSections = {
				[SECTION_ID]: {
					id: SECTION_ID,
					name: formatMessage(messages.projects),
					priority: QUICK_SEARCH_PRIORITY.PROJECTS,
				},
			};

			const commands = getQuickSearchProjectCommands(props);

			return {
				sections,
				commands,
			};
		},
		[formatMessage, getQuickSearchProjectCommands],
	);

	return { getChildResult };
};
